import Button from '@rio-cloud/rio-uikit/Button';
import Icon, { type IconType } from '@rio-cloud/rio-uikit/Icon';

import styles from './NoContentState.module.scss';

export type NoContentStateAction = {
    text: string;
    onClick: () => void;
};

export type NoContentStateProps = {
    iconName: IconType;
    headline: string;
    action?: NoContentStateAction;
};

const NoContentState = ({ iconName, headline, action }: NoContentStateProps) => (
    <div className='display-flex flex-column flex-1-1 align-items-center justify-content-center text-center'>
        <Icon iconName={iconName} className={`text-color-light ${styles.icon}`} />
        <div className='text-size-18 text-medium text-color-dark margin-top-15'>{headline}</div>
        {action ? (
            <Button className='margin-top-15' bsStyle={Button.PRIMARY} onClick={action.onClick}>
                {action.text}
            </Button>
        ) : null}
    </div>
);

export default NoContentState;
